<template>
  <div class="privacy content">
    <div v-html="markdownContent"></div>
  </div>
</template>

<script>
import marked from 'marked'

export default {
  computed: {
    markdownContent () {
      let content = `
## Privacy Policy
      `
      return marked(content)
    }
  }
}
</script>
